import React from 'react'
import { IconClose } from 'components/Zui/Icon'
import { ScrollableDirective } from 'components/Zui'
function Foss({ onClose }) {
    return (
        <>
            <div className="settings-wrapper">
                <div className="setting-header-wrapper">
                    <div className="setting-header-title">
                        <span>Free and open source software</span>
                    </div>
                    <div className="close-setting-wrapper" onClick={onClose}>
                        <div className="user-settings-close-button">
                            <IconClose size="m" className="close-setting-icon" />
                        </div>
                    </div>
                </div>
                <div className="legal-details-wrapper">
                    <ScrollableDirective style={{ maxHeight: '100%' }}>
                        <div className="legal-content-wrapper">
                            <div className="legal-content-container">
                                <div className="content-heading">
                                    <span>Free and open source software</span>
                                </div>
                                <div className="company-title">
                                    <span>ZEISS Surgical Cloud</span>
                                </div>
                                <div className="legal-content-container">
                                    <div className="license-details">
                                        <div className="license-content content-sub-heading">
                                            AppCenter
                                        </div>
                                        <div className="license-content">Version: 3.0.0</div>
                                        <div className="license-content">
                                            License: The MIT License (MIT) Copyright (c) 2017
                                            Microsoft Corporation All rights reserved:
                                            <br />
                                            <a
                                                href="https://github.com/microsoft/appcenter-sdk-apple/blob/develop/LICENSE"
                                                target="blank"
                                            >
                                                https://github.com/microsoft/appcenter-sdk-apple/blob/develop/LICENSE
                                            </a>
                                        </div>
                                    </div>
                                    <div className="legal-content">
                                        <div>
                                            Permission is hereby granted, free of charge, to any
                                            person obtaining a copy of this software and associated
                                            documentation files (the "Software"), to deal in the
                                            Software without restriction, including without
                                            limitation the rights to use, copy, modify, merge,
                                            publish, distribute, sublicense, and/or sell copies of
                                            the Software, and to permit persons to whom the Software
                                            is furnished to do so, subject to the following
                                            conditions:
                                        </div>
                                        <div>
                                            The above copyright notice and this permission notice
                                            shall be included in all copies or substantial portions
                                            of the Software.
                                        </div>
                                        <div>
                                            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF
                                            ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
                                            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                                            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT
                                            SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
                                            CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
                                            OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR
                                            IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
                                            DEALINGS IN THE SOFTWARE.
                                        </div>
                                    </div>
                                </div>
                                <div className="legal-content-container">
                                    <div className="license-details">
                                        <div className="license-content content-sub-heading">
                                            JWTDecode
                                        </div>
                                        <div className="license-content">Version: 2.4.1</div>
                                        <div className="license-content">
                                            License: The MIT License (MIT) Copyright (c) 2014 Auth0,
                                            Inc. All rights reserved:
                                            <br />
                                            <a
                                                href=" https://github.com/auth0/JWTDecode.swift/blob/master/LICENSE.txt"
                                                target="blank"
                                            >
                                                https://github.com/auth0/JWTDecode.swift/blob/master/LICENSE.txt
                                            </a>
                                        </div>
                                    </div>
                                    <div className="legal-content">
                                        <div>
                                            Permission is hereby granted, free of charge, to any
                                            person obtaining a copy of this software and associated
                                            documentation files (the "Software"), to deal in the
                                            Software without restriction, including without
                                            limitation the rights to use, copy, modify, merge,
                                            publish, distribute, sublicense, and/or sell copies of
                                            the Software, and to permit persons to whom the Software
                                            is furnished to do so, subject to the following
                                            conditions:
                                        </div>{' '}
                                        <div>
                                            The above copyright notice and this permission notice
                                            shall be included in all copies or substantial portions
                                            of the Software.
                                        </div>
                                        <div>
                                            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF
                                            ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
                                            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                                            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT
                                            SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
                                            CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
                                            OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR
                                            IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
                                            DEALINGS IN THE SOFTWARE.
                                        </div>
                                    </div>
                                </div>
                                <div className="legal-content-container">
                                    <div className="license-details">
                                        <div className="license-content content-sub-heading">
                                            p2.OAuth2
                                        </div>
                                        <div className="license-content">Version: 5.0.0</div>
                                        <div className="license-content">
                                            License: Apache License, Version 2.0 (the „License"):
                                            <br />
                                            <a
                                                href=" https://github.com/p2/OAuth2/blob/master/LICENSE.txt"
                                                target="blank"
                                            >
                                                https://github.com/p2/OAuth2/blob/master/LICENSE.txt
                                            </a>
                                        </div>
                                    </div>
                                    <div className="legal-content">
                                        <div>Copyright 2015 Pascal Pfiffner</div>{' '}
                                        <div>
                                            Licensed under the Apache License, Version 2.0 (the
                                            „License"); you may not use this file except in
                                            compliance with the License. You may obtain a copy of
                                            the License at
                                            <a>http://www.apache.org/licenses/LICENSE-2.0</a>
                                        </div>
                                        <div>
                                            Unless required by applicable law or agreed to in
                                            writing, software distributed under the License is
                                            distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
                                            CONDITIONS OF ANY KIND, either express or implied.See
                                            the License for the specific language governing
                                            permissions and limitations under the License.
                                        </div>
                                    </div>
                                </div>
                                <div className="legal-content-container">
                                    <div className="license-details">
                                        <div className="license-content content-sub-heading">
                                            RxCocoa
                                        </div>
                                        <div className="license-content">Version: 5.1.0</div>
                                        <div className="license-content">
                                            License: The MIT License Copyright © 2015 Krunoslav
                                            Zaher All rights reserved:
                                            <br />
                                            <a
                                                href="https://github.com/ReactiveX/RxSwift/blob/master/LICENSE.md"
                                                target="blank"
                                            >
                                                https://github.com/ReactiveX/RxSwift/blob/master/LICENSE.md
                                            </a>
                                        </div>
                                    </div>
                                    <div className="legal-content">
                                        <div>
                                            The MIT License Copyright © 2015 Krunoslav Zaher All
                                            rights reserved. Permission is hereby granted, free of
                                            charge, to any person obtaining a copy of this software
                                            and associated documentation files (the "Software"), to
                                            deal in the Software without restriction, including
                                            without limitation the rights to use, copy, modify,
                                            merge, publish, distribute, sublicense, and/or sell
                                            copies of the Software, and to permit persons to whom
                                            the Software is furnished to do so, subject to the
                                            following conditions:
                                        </div>
                                        <div>
                                            The above copyright notice and this permission notice
                                            shall be included in all copies or substantial portions
                                            of the Software.
                                        </div>
                                        <div>
                                            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF
                                            ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
                                            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                                            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT
                                            SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
                                            CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
                                            OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR
                                            IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
                                            DEALINGS IN THE SOFTWARE.
                                        </div>
                                    </div>
                                </div>
                                <div className="legal-content-container">
                                    <div className="license-details">
                                        <div className="license-content content-sub-heading">
                                            RxDataSources
                                        </div>
                                        <div className="license-content">Version: 4.0.1</div>
                                        <div className="license-content">
                                            License: The MIT License Copyright © 2017
                                            RxSwiftCommunity All rights reserved:
                                            <br />
                                            <a
                                                href="https://github.com/RxSwiftCommunity/RxDataSources/blob/master/LICENSE.md"
                                                target="blank"
                                            >
                                                https://github.com/RxSwiftCommunity/RxDataSources/blob/master/LICENSE.md
                                            </a>
                                        </div>
                                    </div>
                                    <div className="legal-content">
                                        <div>
                                            Permission is hereby granted, free of charge, to any
                                            person obtaining a copy of this software and associated
                                            documentation files (the "Software"), to deal in the
                                            Software without restriction, including without
                                            limitation the rights to use, copy, modify, merge,
                                            publish, distribute, sublicense, and/or sell copies of
                                            the Software, and to permit persons to whom the Software
                                            is furnished to do so, subject to the following
                                            conditions:
                                        </div>
                                        <div>
                                            The above copyright notice and this permission notice
                                            shall be included in all copies or substantial portions
                                            of the Software.
                                        </div>
                                        <div>
                                            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF
                                            ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
                                            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                                            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT
                                            SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
                                            CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
                                            OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR
                                            IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
                                            DEALINGS IN THE SOFTWARE.
                                        </div>
                                    </div>
                                </div>
                                <div className="legal-content-container">
                                    <div className="license-details">
                                        <div className="license-content content-sub-heading">
                                            RxSwift
                                        </div>
                                        <div className="license-content">Version: 5.0.0</div>
                                        <div className="license-content">
                                            License: The MIT License Copyright © 2015 Krunoslav
                                            Zaher All rights reserved:
                                            <br />
                                            <a
                                                href=" https://github.com/ReactiveX/RxSwift/blob/master/LICENSE.md"
                                                target="blank"
                                            >
                                                https://github.com/ReactiveX/RxSwift/blob/master/LICENSE.md
                                            </a>
                                        </div>
                                    </div>
                                    <div className="legal-content">
                                        <div>
                                            Permission is hereby granted, free of charge, to any
                                            person obtaining a copy of this software and associated
                                            documentation files (the "Software"), to deal in the
                                            Software without restriction, including without
                                            limitation the rights to use, copy, modify, merge,
                                            publish, distribute, sublicense, and/or sell copies of
                                            the Software, and to permit persons to whom the Software
                                            is furnished to do so, subject to the following
                                            conditions:
                                        </div>
                                        <div>
                                            The above copyright notice and this permission notice
                                            shall be included in all copies or substantial portions
                                            of the Software.
                                        </div>
                                        <div>
                                            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF
                                            ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
                                            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                                            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT
                                            SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
                                            CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
                                            OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR
                                            IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
                                            DEALINGS IN THE SOFTWARE.
                                        </div>
                                    </div>
                                </div>
                                <div className="legal-content-container">
                                    <div className="license-details">
                                        <div className="license-content content-sub-heading">
                                            RxSwiftExt
                                        </div>
                                        <div className="license-content">Version: 5.2.0</div>
                                        <div className="license-content">
                                            License: The MIT LIcense Copyright (c) 2016-latest
                                            RxSwiftCommunity All rights reserved:
                                            <br />
                                            <a
                                                href=" https://github.com/RxSwiftCommunity/RxSwiftExt/blob/master/LICENSE"
                                                target="blank"
                                            >
                                                https://github.com/RxSwiftCommunity/RxSwiftExt/blob/master/LICENSE
                                            </a>
                                        </div>
                                    </div>
                                    <div className="legal-content">
                                        <div>
                                            Permission is hereby granted, free of charge, to any
                                            person obtaining a copy of this software and associated
                                            documentation files (the "Software"), to deal in the
                                            Software without restriction, including without
                                            limitation the rights to use, copy, modify, merge,
                                            publish, distribute, sublicense, and/or sell copies of
                                            the Software, and to permit persons to whom the Software
                                            is furnished to do so, subject to the following
                                            conditions:
                                        </div>
                                        <div>
                                            The above copyright notice and this permission notice
                                            shall be included in all copies or substantial portions
                                            of the Software.
                                        </div>
                                        <div>
                                            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF
                                            ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
                                            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                                            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT
                                            SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
                                            CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
                                            OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR
                                            IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
                                            DEALINGS IN THE SOFTWARE.
                                        </div>
                                    </div>
                                </div>
                                <div className="legal-content-container">
                                    <div className="license-details">
                                        <div className="license-content content-sub-heading">
                                            SwiftGS1BarCode
                                        </div>
                                        <div className="license-content">Version: 0.4.1</div>
                                        <div className="license-content">
                                            License: The MIT LIcense Copyright (c) 2017 Toni
                                            Hoffmann All rights reserved:
                                            <br />
                                            <a
                                                href=" https://github.com/xremix/SwiftGS1Barcode/blob/master/LICENSE"
                                                target="blank"
                                            >
                                                https://github.com/xremix/SwiftGS1Barcode/blob/master/LICENSE
                                            </a>
                                        </div>
                                    </div>
                                    <div className="legal-content">
                                        <div>
                                            Permission is hereby granted, free of charge, to any
                                            person obtaining a copy of this software and associated
                                            documentation files (the "Software"), to deal in the
                                            Software without restriction, including without
                                            limitation the rights to use, copy, modify, merge,
                                            publish, distribute, sublicense, and/or sell copies of
                                            the Software, and to permit persons to whom the Software
                                            is furnished to do so, subject to the following
                                            conditions:
                                        </div>
                                        <div>
                                            The above copyright notice and this permission notice
                                            shall be included in all copies or substantial portions
                                            of the Software.
                                        </div>
                                        <div>
                                            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF
                                            ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
                                            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                                            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT
                                            SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
                                            CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
                                            OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR
                                            IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
                                            DEALINGS IN THE SOFTWARE.
                                        </div>
                                    </div>
                                </div>
                                <div className="legal-content-container">
                                    <div className="license-details">
                                        <div className="license-content content-sub-heading">
                                            SwiftKeychainWrapper
                                        </div>
                                        <div className="license-content">Version: 3.4.0</div>
                                        <div className="license-content">
                                            License: The MIT License (MIT) Copyright (c) 2014 Jason
                                            Rendel All rights reserved:
                                            <br />
                                            <a
                                                href="https://github.com/jrendel/SwiftKeychainWrapper/blob/develop/LICENSE"
                                                target="blank"
                                            >
                                                https://github.com/jrendel/SwiftKeychainWrapper/blob/develop/LICENSE
                                            </a>
                                        </div>
                                    </div>
                                    <div className="legal-content">
                                        <div>
                                            Permission is hereby granted, free of charge, to any
                                            person obtaining a copy of this software and associated
                                            documentation files (the "Software"), to deal in the
                                            Software without restriction, including without
                                            limitation the rights to use, copy, modify, merge,
                                            publish, distribute, sublicense, and/or sell copies of
                                            the Software, and to permit persons to whom the Software
                                            is furnished to do so, subject to the following
                                            conditions:
                                        </div>
                                        <div>
                                            The above copyright notice and this permission notice
                                            shall be included in all copies or substantial portions
                                            of the Software.
                                        </div>
                                        <div>
                                            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF
                                            ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
                                            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                                            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT
                                            SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
                                            CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
                                            OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR
                                            IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
                                            DEALINGS IN THE SOFTWARE.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ScrollableDirective>
                </div>
            </div>
        </>
    )
}

export default Foss
